export const PLAGIARISM_REPORT_FINAL_STATUSES = ['not paid', 'server core error', 'server error', 'error', 'checked'];
